import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const questionApi = {
  state: {

  },

  mutations: {
    getQuestionList(state, data) {
      data.url = API.question.getQuestionList
      CommonUtils.GetRequest(data)
    },
    addQuestion(state, data) {
      data.url = API.question.addQuestion
      CommonUtils.PostRequest(data)
    },
    delQuestion(state, data) {
      data.url = API.question.delQuestion
      CommonUtils.GetRequest(data)
    },
    getQuestionDetail(state, data) {
      data.url = API.question.getQuestionDetail
      CommonUtils.GetRequest(data)
    },
    updateQuestion(state, data) {
      data.url = API.question.updateQuestion
      CommonUtils.PostRequest(data)
    },
    getQuestionTags(state, data) {
      data.url = API.question.getTagList
      CommonUtils.GetRequest(data)
    },
    delQuestionTag(state, data) {
      data.url = API.question.delTag
      CommonUtils.GetRequest(data)
    },
    // addQuestionTag(state, data) {
    //   data.url = API.question.addTag
    //   CommonUtils.PostRequest(data)
    // },
    getSelectTags(state, data) {
      data.url = API.question.getTagsSelect
      CommonUtils.GetRequest(data)
    }
  }
}

export default questionApi



// WEBPACK FOOTER //
// ./src/store/modules/question.js